import axios from "./api";
// 模块-游戏专区
//部分-首页
export const csInit = () => {
  return axios({
    url: "/v2/cs/csInit",
    method: "get",
    loading: true
  });
};

//部分-我要提问

//获取游戏类别与服务器
export const doFeedback = data => {
  return axios({
    url: "/v2/cs/doFeedback",
    method: "post",
    loading: true,
    data
  });
};
//根据游戏id与服务器id获取游戏名
export const getRoleInfo = data => {
  return axios({
    url: "/v2/cs/getRoleInfo",
    method: "post",
    loading: true,
    data
  });
};

//部分-被盗找回

//手机号是否绑定
export const isBindPhone = () => {
  return axios({
    url: "/v2/cs/isbindphone",
    method: "get",
    loading: true,
    silent: [5003]
  });
};
//获取协议内容
export const contentInit = data => {
  return axios({
    url: "/v2/cs/contentInit",
    method: "post",
    loading: true,
    data
  });
};
//部分-自助服务

//获取账号锁定状态
export const getGameCodeStatus = data => {
  return axios({
    url: "/v2/cs/getGameCodeStatus",
    method: "post",
    loading: true,
    data
  });
};
//更改账号状态，请求后判断账号锁定状态，将锁定置为未锁定，未锁定置为锁定
export const LockAndUnlock = data => {
  return axios({
    url: "/v2/cs/lockAndUnlock",
    method: "post",
    loading: true,
    data
  });
};
//提供给巫神归来的账号自助锁定/解锁
export const getServerList = data => {
  return axios({
    url: "/v2/cs/getServerList",
    method: "post",
    loading: false,
    data
  });
};

//自助服务

//部分-我的提单（二）
export const clearLock = data => {
  return axios({
    url: "/v2/cs/clearLock",
    method: "post",
    loading: true,
    data
  });
};
//提单列表
export const getWorksheetList = data => {
  return axios({
    url: "/v2/cs/myWorksheetList",
    method: "post",
    loading: true,
    data
  });
};
//提单详情
export const worksheetDetail = data => {
  return axios({
    url: "/v2/cs/worksheetDetail",
    method: "post",
    loading: true,
    data
  });
};
//问题回复
export const doResponse = data => {
  return axios({
    url: "/v2/cs/doresponse",
    method: "post",
    loading: true,
    data
  });
};
//提单页面初始化
export const feedbackInit = data => {
  return axios({
    url: "/v2/cs/feedbackInit",
    method: "post",
    loading: true,
    data,
    silent: [3001]
  });
};

//模块-账号申诉

//申诉
export const appeal = data => {
  return axios({
    url: "/v2/cs/appeal",
    method: "post",
    loading: true,
    data
  });
};
//申诉查询
export const queryAppeal = data => {
  return axios({
    url: "/v2/cs/queryappeal",
    method: "post",
    loading: true,
    data
  });
};

//提交新的安全信息
export const doResetInfo = data => {
  return axios({
    url: "/v2/cs/doResetInfo",
    method: "post",
    loading: true,
    data
  });
};

//提交新的安全信息
export const getResetInfo = data => {
  return axios({
    url: "/v2/cs/getResetInfo",
    method: "post",
    loading: true,
    data
  });
};

//模块-客服电话模块

//公共接口

//上传图片
export const uploadPicture = () => {
  return axios({
    url: "/v2/cs/uploadpicture",
    method: "post",
    loading: true
  });
};

//校验手机号
export const checkCode = () => {
  return axios({
    url: "/v2/cs/checkcode",
    method: "post",
    loading: true
  });
};

// 获取验证码 --客服中心
export const sendCodeC = data => {
  return axios({ url: "/v2/cs/sendSms", method: "post", data, loading: true });
};

//身份证上传
export const getIdentifyData = data => {
  return axios({
    url: "/v2/cs/getIdentifyData",
    method: "post",
    data,
    loading: true
  });
};
